module.exports = __webpack_public_path__ + "img/real_conversion_rate.639c3344.svg";